import React from 'react';
import './PartnersCollaborations.scss';

const PartnersCollaborations = () => {
  return (
    <section className="partners-section">
      <div className="container">
        <div className="partners-header">
          <div className="partners-title-section">
            <h2 className="section-title">Partners & Collaborations</h2>
            <p className="section-subtitle">
              Working together for energy access in Africa.
            </p>
          </div>
          <a href="#" className="view-all-link">View All Partners →</a>
        </div>

        <div className="partners-grid">
          <div className="partner-card">
            <div className="partner-logo">
              <img src="/images/partners/vasudha-foundation.png" alt="Vasudha Foundation USA logo" className="logo-image" />
            </div>
            <div className="partner-info">
              <h3 className="partner-name">VASUDHA FOUNDATION</h3>
            </div>
          </div>

          <div className="partner-card">
            <div className="partner-logo">
              <img src="/images/partners/access-coalition.png" alt="ACCESS Coalition logo" className="logo-image" />
            </div>
            <div className="partner-info">
              <h3 className="partner-name">ACCESS Coalition</h3>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PartnersCollaborations;
